"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _mockedFreeMerchandiseItems = _interopRequireDefault(require("self-service-api/constants/mockedFreeMerchandiseItems"));

var productsAdapter = function productsAdapter(_ref) {
  var productCatalog = _ref.productCatalog,
      customerCurrencyCode = _ref.customerCurrencyCode;
  var additionalInfo = {
    customerCurrencyCode: customerCurrencyCode,
    authState: 'AUTHED'
  };
  var products = productCatalog.reduce(function (aggregate, item) {
    var merchandiseId = item.merchandiseItemId;
    aggregate[merchandiseId] = (0, _extends2.default)({
      ownedByHub: item.ownedByHub,
      eligibility: item.eligibility
    }, item.merchandiseItem);
    return aggregate;
  }, (0, _extends2.default)({}, _mockedFreeMerchandiseItems.default));
  return (0, _extends2.default)({}, additionalInfo, {
    products: products
  });
};

var _default = productsAdapter;
exports.default = _default;
module.exports = exports.default;